import { render, staticRenderFns } from "./SpecialInstructionDialog.vue?vue&type=template&id=2cdd6963"
import script from "./SpecialInstructionDialog.vue?vue&type=script&lang=js"
export * from "./SpecialInstructionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports